import tw, { styled, css } from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';

export const StyledLinksWrapper = styled.div<{ hasSubheadline: boolean }>`
  ${tw`flex flex-col`}
  ${tw`gap-[12px]`}
  ${tw`pb-1`}
  ${tw`mt-1`}
  ${({ hasSubheadline }) => hasSubheadline && tw`mt-[9px] lg:mt-[15px]`}
`;

export const StyledImage = styled(ImageElement)`
  ${tw`w-full lg:w-[272px]`}
  ${tw`rounded-lg`}
`;

export const StyledSubheadlineWrapper = styled.div`
  ${tw`px-1 pt-1`}
  ${tw`mb-1`}
`;

const SubheadlineStyles = css`
  ${tw`font-poppins lg:font-inter font-semi-bold tracking-extra`};
  ${tw`text-tag-l lg:text-body-xs text-primary-p1 lg:text-secondary-s1`};
  ${tw`pb-1 lg:pb-0`}
  ${tw`border-b lg:border-none border-neutrals-n7`}
`;

export const StyledSubHeadline = styled.div`
  ${SubheadlineStyles}
`;

export const StyledSubHeadlineLink = styled.a`
  ${tw`block`}
  ${SubheadlineStyles}
`;
export const StyledContentTitle = styled.span`
  ${tw`font-semi-bold`}
  ${tw`text-neutrals-n7`}
`;
